import { DateTime } from 'luxon';

export const isToday = (day: DateTime<boolean>) => {
  return day.hasSame(DateTime.local(), 'day');
};
